module.exports = __webpack_public_path__ + "static/media/mp3.a28bccd4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/scenes/Files/images/mp3.svg
// module id = 601
// module chunks = 0